<script>
import { mapGetters } from 'vuex';
import ProductAttributesMixin from '../mixins/product-attributes';
import ProductApplications from '../ProductApplications.vue';

export default {
  name: 'CompareListTablePropertyCell',
  components: { ProductApplications },
  props: ['product', 'property'],
  mixins: [ProductAttributesMixin],
  computed: {
    ...mapGetters({
      products: 'compare/products',
      highlightsDifferences: 'compare/highlightDifferences',
    }),
    canHighlightCell() {
      return this.isUniqueProperty()
        && this.getPropertyValues(this.property.name).length
        && this.highlightsDifferences;
    },
  },
  methods: {
    isUniqueProperty() {
      const propertyName = this.property.name;
      const propertyValue = this.getPropertyValues(this.property.name);
      return !this.products.filter((product) => product.id !== this.product.id)
        .find((product) => {
          const property = product.properties.find((p) => p.name === propertyName);
          const pValue = (property && property.values) ? property.values.join(', ') : '';
          return pValue === propertyValue;
        });
    },
  },
};
</script>

<template>
  <td v-if="property.name == 'Application'">
    <ProductApplications :product="product" />
  </td>
  <td v-else :class="{ 'bg-orange-200 border border-orange-diagomics-light': canHighlightCell }">
    {{ this.getPropertyValues(property.name) || this.getOptionValues(property.name) }}
  </td>
</template>
